import { __assign } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../PnmacDatePicker.styles.js';
import { DatePicker, LocalizationProvider } from "@material-ui/pickers";
import MomentUtils from '@material-ui/pickers/adapter/moment';
import TextField from '@material-ui/core/TextField';
var OTPDatePicker = function (allprops) {
  return /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: MomentUtils
  }, /*#__PURE__*/React.createElement(DatePicker, __assign({
    renderInput: function (props) {
      var _a, _b;
      return /*#__PURE__*/React.createElement(TextField, __assign({
        id: (_a = allprops.id) !== null && _a !== void 0 ? _a : "standard-id",
        label: (_b = allprops.label) !== null && _b !== void 0 ? _b : "standard-basic-label"
      }, props, {
        inputProps: __assign({
          style: {
            textAlign: 'right',
            paddingLeft: 5,
            paddingRight: 5
          }
        }, props.inputProps)
      }));
    },
    autoOk: allprops.autoOk,
    variant: allprops.variant,
    inputVariant: allprops.inputVariant,
    disablePast: allprops.disablePast,
    format: allprops.format,
    maxDate: allprops.maxDate,
    shouldDisableDate: allprops.shouldDisableDate,
    minDateMessage: allprops.minDateMessage,
    maxDateMessage: allprops.maxDateMessage,
    style: allprops.style,
    value: allprops.value,
    onChange: allprops.onChange,
    InputAdornmentProps: allprops.InputAdornmentProps,
    animateYearScrolling: allprops.animateYearScrolling
  }, allprops)));
};
OTPDatePicker.propTypes = {};
export default OTPDatePicker;